import { cidPopover } from './_cidPopover';
import { cidOrientationChange } from './_cidPopover';
import { scrollTo } from '../../utils/_scrollTo';
import { displayDynamicShippingAlert } from './_displayDynamicShippingAlert';
import { highlightZipcodeOnPaymentError } from './_highlightZipcodeOnPaymentError';
import { allDevicesIsInternationalRegistry } from './_isInternationalRegistry';
import { isSavedCardDillardsCharge2 } from './_isDillardsCharge';
import { allDevicesCharCountGiftBox } from './_giftBox';
import { allDevicesCharCountLineItemGiftMsg } from './_giftMessage';
import { allDevicesCheckoutAddress } from './_checkoutAddress';
import { allDevicesDeclineGift } from './_declineGift';
import { allDevicesDisplayMultiShip } from './_displayMultiShip';
import { allDevicesGiftboxMessageItem } from './_giftBox';
import {
	allDevicesQcOrBillingAddressRadioSelected,
	allDevicesRegistryAddressRadio,
	allDevicesShippingSavedAddressRadio,
	allDevicesHoldAtLocationRadio,
} from './_addressRadio';
import { allDevicesSetItemGiftMessage, allDevicesUpdateGiftMessage } from './_giftMessage';
import { addAddressSubmit } from './_addAddress';
import {
	// allDevicesUpdateShipMode,
	allDevicesUpdateGlobalShipMode,
	// allDevicesSingleUpdateShippingAddress,
	storePickupRadio,
	massUpdateShippingAddress,
	displayItemsWithRestrictions,
	storePickup,
} from './_updateShipping';
import { showOrderItemAddressSelectionDisplay } from './_showOrderItemAddressSelectionDisplay';
import { showOrderItemShipModeSelectionDisplay } from './_showOrderItemShipModeSelectionDisplay';
import { showGlobalShipModeDisplay } from './_showGlobalShipModeDisplay';
import { updateGiftWrapValue } from './_updateGiftWrapValue';
import { disableUnnecessaryFields } from './_disableUnnecessaryFields';
import { submitShippingForm } from './_submitShippingForm';
import { submitPaymentForm } from './_submitPaymentForm';
import { showAvailableRewards } from '../../checkout/_payment';
import { isDillardsChargeSelected2, isDillardsChargeEntered2 } from './_isDillardsCharge';
import { checkShowPin, showHidePin } from './_pin';
import { removeGiftCardFromPayment } from './_removeGiftCardFromPayment';
import { isDillardsGiftCard } from './_isDillardsGiftCard';
import { tap2zoom_wl } from '../../modules/productDisplay/_images';
import { showStorePickupTopDisplay } from './_showStorePickupTopDisplay';
import { showOrderItemStorePickupDisplay } from './_showOrderItemStorePickupDisplay';
import { showStorePickupHeader } from './_showStorePickupHeader';
import { allDevicesPickUpStoreReset } from './_pickUpStoreReset';
import { setupAjaxPromoValidate } from './_validatePromo';
import { setupAfterpayExpress, initAfterpay } from './_afterpay';
import Cookies from 'js-cookie';
var billingPage = () => {
	if ($('#billingWrapper').length > 0) {
		highlightZipcodeOnPaymentError();
	}
};

var orderCompletePage = () => {
	if ($('#orderCompletePage').length > 0) {
		//        if ($('#isPostMasterCall').html()) {
		//            var value = Cookies.get("cptc"),
		//                orderId = $('#orderId').html();
		//            if (value != "" && value != null) {
		//                var ajaxOptions = {
		//                    type: "POST",
		//                    dataType: "html",
		//                    url: "/webapp/wcs/stores/servlet/PostMaster",
		//                    data: "catalogId=" + 301 + "&storeId=" + 301 + "&langId=" + -1 + "&cptc=" + value + "&orderId=" + orderId,
		//                };
		//                $.ajax(ajaxOptions);
		//            }
		//        }
	}
};

var paymentPage = () => {
	if ($('#paymentPage').length > 0) {
		cidPopover();
		cidOrientationChange();
		$('input[name=account],input[name=pay_data_cvvNumber],input[name=cvv],input[name=giftCertificate],input[name=pin]').keydown(function (e) {
			// Allow: backspace, delete, tab, escape, enter and .
			
			if (
				$.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
				// Allow: Ctrl+A
				(e.keyCode == 65 && e.ctrlKey === true) ||
				// Allow: Ctrl+C
				(e.keyCode == 67 && e.ctrlKey === true) ||
				// Allow: Ctrl+X
				(e.keyCode == 88 && e.ctrlKey === true) ||
				// Allow: crtl+v
				(e.keyCode == 86 && e.ctrlKey === true) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)
			) {
				// let it happen, don't do anything
				return;
			}
			// Ensure that it is a number and stop the keypress
			if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) e.preventDefault();
		});

		$('#cardNumber').on('input', function (e) {
			var getCardNumber = $('#cardNumber').val();
			var removeSpaces = getCardNumber.replace(/\s/g, '');
			var trimmedVal =  removeSpaces.trim();
			$('#cardNumber').val(trimmedVal);
			if ($('#paymentMethod').val() === '11052,VISA') {
				$('.card-type.visa').show();
				$('.card-type.dillards-mastercard').hide();
				$('.card-type.private-label').hide();
				$('.cvv-text-amex').hide();
				$('.card-type.front').hide();
				$('.card-type.back').show();
				$('.cvv-text').show();
			} else {
				$('.card-type.visa').hide();
			}

			if ($('#paymentMethod').val() === '11055,Discover') {
				$('.card-type.discover').show();
				$('.card-type.dillards-mastercard').hide();
				$('.card-type.private-label').hide();
				$('.cvv-text-amex').hide();
				$('.card-type.front').hide();
				$('.card-type.back').show();
				$('.cvv-text').show();
			} else {
				$('.card-type.discover').hide();
			}

			if ($('#paymentMethod').val() === '11053,Master Card') {
				$('.card-type.mastercard').show();
				$('.card-type.dillards-mastercard').hide();
				$('.card-type.private-label').hide();
				$('.cvv-text-amex').hide();
				$('.card-type.front').hide();
				$('.card-type.back').show();
				$('.cvv-text').show();
			} else {
				$('.card-type.mastercard').hide();
			}

			if ($('#paymentMethod').val() === '11056,Dillards Charge') {
				$('.dillards-card.basic').show();
				$('.card-type.dillards-mastercard').hide();
				$('.card-type.private-label').hide();
				$('.cvv-text-amex').hide();
				$('.card-type.front').hide();
				$('.card-type.back').show();
				$('.cvv-text').show();
			} else {
				$('.dillards-card.basic').hide();
			}

			if ($('#paymentMethod').val() === '11057,Dillards AMEX Charge') {
				$('.dillards-card.elite').show();
				$('.card-type.dillards-mastercard').hide();
				$('.card-type.private-label').hide();
				$('.card-type.back').hide();
				$('.cvv-text').hide();
				$('.cvv-text-amex').show();
				$('.card-type.front').show();
			} else {
				$('.dillards-card.elite').hide();
			}

			if ($('#paymentMethod').val() === '11054,AMEX') {
				$('.card-type.amex').show();
				$('.card-type.dillards-mastercard').hide();
				$('.card-type.private-label').hide();
				$('.card-type.back').hide();
				$('.cvv-text').hide();
				$('.cvv-text-amex').show();
				$('.card-type.front').show();
			} else {
				$('.card-type.amex').hide();
			}
			if ($('#paymentMethod').val() === '11063,Dillards Mastercard') {
				$('.card-type.dillards-mastercard').show();
				$('.card-type.private-label').hide();
				$('.card-type.discover').hide();
				$('.cvv-text-amex').hide();
				$('.card-type.front').hide();
				$('.card-type.back').show();
				$('.cvv-text').show();
			} else {
				$('.dillards-card.dillards-mastercard').hide();
			}
			if ($('#paymentMethod').val() === '11064,Dillards Private Label') {
				$('.card-type.private-label').show();
				$('.card-type.dillards-mastercard').hide();
				$('.card-type.discover').hide();
				$('.cvv-text-amex').hide();
				$('.card-type.front').hide();
				$('.card-type.back').show();
				$('.cvv-text').show();
			} else {
				$('.dillards-card.private-label').hide();
			}
			if ($('#paymentMethod').val() === '0,noCardSelected') {
				$('.card-type.back').hide();
				$('.card-type.front').hide();
				$('.cvv-text').hide();
				$('.cvv-text-amex').hide();
			} else {
			}
		});

		$('#savedCard').on('ifChecked', function (event) {
			isSavedCardDillardsCharge2();
		});
		showHidePin($('input[name=giftCertificate]').val());
		// Check for remaining amount less than or equal to zero.
		var remainingAmount = $('#remainingAmount').html(),
			giftCardsTotal = $('#giftCardsTotal').html(),
			orderTotal = $('#formattedOrderTotal').html(),
			showNewCards = function () {
				$('#qcProfile2').hide();
				$('#newCards2').show();
				$('#wfCard').hide();
				$('#wfDillardsCard').hide();
				$('#order-review-button').show();
				//$("#paypal-payment-button").hide();
			},
			showQCProfile = function () {
				$('#newCards2').hide();
				$('#qcProfile2').show();
				$('#wfCard').hide();
				$('#wfDillardsCard').hide();
				$('#order-review-button').show();
				// $("#paypal-payment-button").hide();
			},
			showWFCard = function () {
				$('#newCards2').hide();
				$('#qcProfile2').hide();
				$('#wfCard').show();
				$('#wfDillardsCard').show();
				$('#order-review-button').show();
				// $("#paypal-payment-button").hide();
			},
			showPaypal = function () {
				$('#newCards2').hide();
				$('#qcProfile2').hide();
				$('#wfCard').hide();
				$('#wfDillardsCard').hide();
				$('#order-review-button').hide();
				$('#paypal-payment-button').show();
			};
		if (remainingAmount <= 0)
			orderTotal <= giftCardsTotal
				? displayDynamicShippingAlert('You have entered sufficient amount using gift cards. Please hit Continue to Order Review to proceed.', 'success')
				: displayDynamicShippingAlert('You have entered more credit cards than necessary. Please remove to proceed.', 'danger');
		/* to make sure that the CVN field is hidden if the first saved card is Dillards Charge */
		if ($('#wfEncAccount').length > 0) {
			showWFCard();
		} else if ($('form[name=QuickCheckoutCC2]').length > 0) {
			isSavedCardDillardsCharge2();
			$('#newCards2').css('display', 'none');
			$('#wfDillardsCard').hide();
		}
		$('#addCCtoProfile').on('change', function () {
			document.creditcard2.addCCtoProfile.value = $(this).prop('checked');
		});
		$('input[name=CardType2]:radio').click(function () {
			if ($(this).val() == 'newCard2') {
				//    	payPalPayWithCardSpeedBump();
				showNewCards();
			} else if ($(this).val() == 'wfCard') {
				//    	payPalPayWithCardSpeedBump();
				showWFCard();
			} else if ($(this).val() == 'paypalRadio') {
				showPaypal();
			} else {
				//    	  payPalPayWithCardSpeedBump();
				showQCProfile();
			}
		});

		if ($('#paymentWrapper .alert-success').length > 0 || $('#paymentWrapper .alert-danger').length > 0) {
			setTimeout(function() {
			scrollTo('.gc-id');
			}, 500);
		}

		$('.cardOptionsRadio:radio').on('ifChecked', function (event) {
			if ($(this).val() == 'savedCard2') {
				showQCProfile();
			} else {
				showNewCards();
			}
		});
		$('.removeReward').on('click', function () {
			var reward = $(this).data('reward');
			var index = reward.substr(reward.length - 1);
			$('input[name=' + reward + ']').val('');
			$('#appliedPromo' + index).remove();
		});

		$('#gcPin').on('input', function() {
			if ($('#gcPin').val().length === 3) {
				$('#pinLengthError, #newPinError').remove();
			}
		});

		$('.collapse-button').on('click', function(e) {
			e.preventDefault();
			const id = $(this).attr('id')
			const collapsableDivId = id.split('collapse-')[1]
			var element = document.getElementById(collapsableDivId);
  			element.classList.toggle("hidden");
			$(this).toggleClass("closed");
		})
	}
};

var summaryPage = () => {
	if ($('#summaryPage').length > 0) $('#oldGECardReplacedModalClick').click();
};

var wishlistDisplay = () => {
	if ($('#wishlistDisplay').length > 0) {
		var country = Cookies.get('zCountry');
		if (country === null || country === undefined || country == 'US' || country === '') {
			var fullyLoggedOn = $('#wishlistDisplay').data('fullyLoggedOn'),
				wishlist = {
					type: 'GET',
					dataType: 'html',
					url: '/webapp/wcs/stores/servlet/ShoppingCartInterestItems',
					data: 'catalogId=' + 301 + '&storeId=' + 301 + '&langId=' + -1 + '&fullyLoggedOn=' + fullyLoggedOn,
					success: function (html) {
						$('#wishlistDisplay').html(html);
						allDevicesIsInternationalRegistry();
						window.wlToggleMode = false;
						tap2zoom_wl();
					},
				};
			$.ajax(wishlist);
			return false;
		}
	}
};

var shippingPage = () => {
	if ($('#shippingPage').length > 0) {
		allDevicesCharCountGiftBox();
		allDevicesCharCountLineItemGiftMsg();
		allDevicesCheckoutAddress();
		allDevicesDisplayMultiShip();
		allDevicesGiftboxMessageItem();
		allDevicesShippingSavedAddressRadio();
		allDevicesRegistryAddressRadio();
		allDevicesHoldAtLocationRadio();
		allDevicesPickUpStoreReset();
		$('.shipModeSelect select').each(function () {
			if ($(this).find('option').html() == 'Cannot be shipped to this address') {
				$(this).css('color', 'red');
			}
		});

		if ($("[name='restrictedItem']").length > 0) {
			var restrictedItems = [];
			$.each($("[name='restrictedItem']"), function () {
				restrictedItems.push(this.value);
			});
			displayItemsWithRestrictions(restrictedItems);
		}
	}
};

var payPalPayWithCardSpeedBump = () => {
	var isPayPal = $('span#isPayPalBilling');

	if (typeof isPayPal !== 'undefined' && isPayPal.length > 0 && isPayPal.text() == 'true') {
		var payWithCard = document.createElement('a');
		payWithCard.setAttribute('data-toggle', 'modal');
		payWithCard.setAttribute('id', 'payPalChangeCreditCardModal');
		payWithCard.setAttribute('data-target', 'modal-paypal-credit-speed-bump');
		payWithCard.setAttribute('data-modal-title', 'Pay with credit card instead');
		payWithCard.setAttribute('target', '_blank');
		payWithCard.setAttribute('data-modal-body', 'infoBoxModals({"espotName":"DDS_PayPal_use_card_instead"})');
		$('#paypal-payment-button').append(payWithCard);
		$('#payPalChangeCreditCardModal').click();
	}
};

var cartPage = () => {
	if ($('#cartWrapper').length > 0) {
		setupAjaxPromoValidate();
	}

	setupAfterpayExpress();

	function updateSubscription(subChoice, subFreq) {
		if (typeof Storage !== 'undefined') {
			var tVal = decodeURIComponent(localStorage.getItem('tVal'));
			if ($('form#ShopCartForm input[name=tVal]').length) {
				$('form#ShopCartForm input[name=tVal]').val(tVal);
			} else {
				var input = document.createElement('input');
				input.type = 'hidden';
				input.name = 'tVal';
				input.value = tVal;
				$('form#ShopCartForm').append(input);
			}
		}
		$.ajax({
			type: 'POST',
			url: '/webapp/wcs/stores/servlet/OrderItemUpdate',
			data: $('#ShopCartForm').serialize(),
		}).then(function (response) {
			if (typeof Storage !== 'undefined') {
				var search = $(response).find('a.remove_tVal:first');
				if (search.length > 0) {
					var href = $(search[0]).prop('href');
					var res1 = href.split('tVal=');
					var res2 = res1[1].split('&');
					var tVal = res2[0];
					localStorage.setItem('tVal', tVal);
				}
			}
		});
	}

	$(document).on('change.frequencyRadio', 'input[name^=subFrequencyRadio]', function () {
		var freqEl = $(this).parents('tr').find('select[name^=tieShipCode]').get(0);
		var targetValue = $(this).val();

		if (targetValue == 'subscribe') {
			var options = freqEl.options;
			for (var i = 0; i < options.length; i++) {
				var option = options[i];
				if (option.value == '') {
					freqEl.removeChild(option);
				}
			}

			freqEl.disabled = false;
		} else {
			freqEl.appendChild(new Option('Select Frequency', ''));
			freqEl.value = '';
			freqEl.disabled = true;
		}

		var subscribeChecked = $('input[id^=subFrequencyRadio_subscribe]:checked').length > 0;

		$('div[id^=paypal-express-checkout-button]').toggle(!subscribeChecked);
		if (window.navigator.userAgent.indexOf('Trident/') === -1 && window.navigator.userAgent.indexOf('Edge/') === -1) {
			$('.afterpay-express-button').toggle(!subscribeChecked);
		}
		if(window.ApplePaySession && window.ApplePaySession.canMakePayments() && window.ApplePaySession.canMakePaymentsWithActiveCard()){
			$('apple-pay-button').toggle(!subscribeChecked);
		}
		$('.subQcModalFooter').toggle(subscribeChecked);
		$('.qcModalFooter').toggle(!subscribeChecked);
		$('#shopCart-continue-shopping-top-sub').toggle(subscribeChecked);
		$('#shopCart-continue-shopping-bottom-sub').toggle(subscribeChecked);

		if (subscribeChecked) {
			$('input[name=subscriptions]').val('true');
		} else {
			$('input[name=subscriptions]').val('false');
		}

		updateSubscription();
	});

	$(document).on('change.tieShipCode', 'select[name^=tieShipCode]', function () {
		updateSubscription();
	});
};

if (typeof Dillards !== 'undefined') {
	Dillards.allDevicesSetItemGiftMessage = allDevicesSetItemGiftMessage;
	Dillards.allDevicesUpdateGiftMessage = allDevicesUpdateGiftMessage;
	Dillards.allDevicesQcOrBillingAddressRadioSelected = allDevicesQcOrBillingAddressRadioSelected;
	// Dillards.allDevicesSingleUpdateShippingAddress = allDevicesSingleUpdateShippingAddress;
	// Dillards.allDevicesUpdateShipMode = allDevicesUpdateShipMode;
	Dillards.allDevicesUpdateGlobalShipMode = allDevicesUpdateGlobalShipMode;
	Dillards.showOrderItemAddressSelectionDisplay = showOrderItemAddressSelectionDisplay;
	Dillards.showOrderItemShipModeSelectionDisplay = showOrderItemShipModeSelectionDisplay;
	Dillards.showGlobalShipModeDisplay = showGlobalShipModeDisplay;
	Dillards.updateGiftWrapValue = updateGiftWrapValue;
	Dillards.disableUnnecessaryFields = disableUnnecessaryFields;
	Dillards.submitShippingForm = submitShippingForm;
	Dillards.showAvailableRewards = showAvailableRewards;
	Dillards.submitPaymentForm = submitPaymentForm;
	Dillards.isDillardsChargeSelected2 = isDillardsChargeSelected2;
	Dillards.isDillardsChargeEntered2 = isDillardsChargeEntered2;
	Dillards.checkShowPin = checkShowPin;
	Dillards.removeGiftCardFromPayment = removeGiftCardFromPayment;
	Dillards.massUpdateShippingAddress = massUpdateShippingAddress;
	Dillards.storePickup = storePickup;
	Dillards.addAddressSubmit = addAddressSubmit;
	Dillards.isSavedCardDillardsCharge2 = isSavedCardDillardsCharge2;
	Dillards.isDillardsGiftCard = isDillardsGiftCard;
	Dillards.showStorePickupTopDisplay = showStorePickupTopDisplay;
	Dillards.showStorePickupHeader = showStorePickupHeader;
	Dillards.showOrderItemStorePickupDisplay = showOrderItemStorePickupDisplay;
	Dillards.allDevicesPickUpStoreReset = allDevicesPickUpStoreReset;
	Dillards.initAfterpay = initAfterpay;
}

export const allDevicesSetupCheckoutPages = () => {
	billingPage();
	shippingPage();
	paymentPage();
	summaryPage();
	orderCompletePage();
	wishlistDisplay();
	cartPage();
};
